import React from "react";

const Arrow = props => {
    return(
      <svg className="slider__arrow" xmlns="http://www.w3.org/2000/svg" width="45" height="30" viewBox="0 0 58 42">
        <polygon fill={props.color} points="5.8,4.9 52.2,4.9 29,38.6" />
        <path fill="#ffffff"  d="M48.4,6.9L29,35.1L9.6,6.9H48.4 M56,2.9h-7.6H9.6H2l4.3,6.3l19.4,28.1l3.3,4.8l3.3-4.8L51.7,9.2L56,2.9L56,2.9z"/>
      </svg>
);
}

export default Arrow